import Button from "./Button";
import React, { useState, useEffect, useMemo } from "react";
import Cross from "../assets/svgs/Cross";
import { useLocation, useNavigate } from "react-router-dom";
import { useRegistrationForm } from "./RegistrationFormProvider";

export const Headline = ({ openEnquireForm }) => {
    const [show, setShow] = useState(true);
    const [showBlockParty, setShowBlockParty] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    const { toggleRegistrationForm } = useRegistrationForm();

    // Check if block party headline should be shown (between today and Oct 26, 2025)
    const isBlockPartyActive = useMemo(() => {
        return false;
        // try {
        //     const start = new Date("2025-10-02T00:00:00");
        //     const end = new Date("2025-10-26T23:59:59");
        //     const now = new Date();
        //     return now >= start && now <= end;
        // } catch (e) {
        //     return false;
        // }
    }, []);

    // Hide the headline on specific routes or when EnquireForm is open
    useEffect(() => {
        if (
            location.pathname === "/register" ||
            location.pathname === "/enquire" ||
            location.pathname === "/house-and-land-packages" ||
            location.pathname === "/block-party" ||
            location.pathname === "/land-for-sale" ||
            location.pathname === "/building-resources" ||
            location.pathname === "/construction-updates" ||
            openEnquireForm
        ) {
            setShow(false);
            setShowBlockParty(false);
        } else {
            setShow(true);
            setShowBlockParty(true);
        }
    }, [location.pathname, openEnquireForm]);

    // Don't render if we're on specific pages or EnquireForm is open
    if (
        location.pathname === "/register" ||
        location.pathname === "/house-and-land-packages" ||
        location.pathname === "/block-party" ||
        location.pathname === "/land-for-sale" ||
        location.pathname === "/building-resources" ||
        location.pathname === "/construction-updates" ||
        openEnquireForm
    ) {
        return null;
    }

    const handleViewEvent = () => {
        navigate("/block-party");
    };

    return (
        <>
            {/* Block Party Headline - Shows above land release headline */}
            {isBlockPartyActive && (
                <div
                    className={`${
                        showBlockParty ? "block" : "hidden"
                    } bg-gableGreen/75 backdrop-blur-md shadow-xl fixed ${
                        show ? "bottom-[12pnpm0px] sm:bottom-[380px] xl:bottom-[370px]" : "bottom-70"
                    } m-auto left-0 sm:left-auto right-0 sm:right-10 xl:right-59 p-6 sm:p-10 w-90 sm:w-full sm:max-w-450 xl:max-w-548 z-20 transition-all duration-300`}
                >
                    <div className="flex justify-between items-center">
                        <p className="font-tobias text-honeysuckle text-2xl sm:text-3xl lg:text-4xl leading-tight">
                            You're Invited to the Banyan Hill Block Party
                        </p>
                        <div className="cursor-pointer ml-2" onClick={() => setShowBlockParty(false)}>
                            <Cross className="w-4 sm:w-6 xl:w-8" />
                        </div>
                    </div>
                    <p className="font-mori text-honeysuckle text-base sm:text-lg font-semibold mt-3 mb-2">
                        Sunday 26 October<br />12-3pm
                    </p>
                    <p className="font-mori text-honeysuckle text-sm sm:text-base lg:text-lg leading-5 lg:leading-6 mb-4 sm:mb-6">
                        Bring the family along and join us for a fun-filled afternoon and discover the latest in home innovation and design excellence at our display village.
                    </p>
                    <Button
                        title="View Event Now"
                        className="hover:bg-honeysuckle hover:text-gableGreen"
                        onClick={handleViewEvent}
                    />
                </div>
            )}

            {/* Land Release Headline */}
            <div
                className={`${
                    show ? "block" : "hidden"
                } bg-gableGreen/75 backdrop-blur-md shadow-xl fixed bottom-70 m-auto left-0 sm:left-auto right-0 sm:right-10 xl:right-59 p-6 sm:p-10 w-90 sm:w-full sm:max-w-450 xl:max-w-548 z-20`}
            >
                <div className="flex justify-between items-center">
                    <p className="font-tobias text-honeysuckle text-3xl sm:text-4xl lg:text-5xl">
                        Land Now Selling
                    </p>
                    <div className="cursor-pointer" onClick={() => setShow(false)}>
                        <Cross className="w-4 sm:w-6 xl:w-8" />
                    </div>
                </div>
                <p className="font-mori text-honeysuckle text-sm sm:text-base lg:text-lg leading-5 lg:leading-6 my-4 sm:my-6">
                    Hedgerow Release is now selling. Lots from 454m2 to 697m2 from $518,950
                </p>
                <Button
                    title="View Now"
                    className="hover:bg-honeysuckle hover:text-gableGreen"
                    onClick={() => navigate('/land-for-sale')}
                />
            </div>
        </>
    );
};

export default Headline;
